/* ******************** STAFF MARKUP ******************** */
// [[src/assets/js/components/templates/_staff-card.js]]
// [[src/assets/js/pages/staff-page.js]]
import { html } from "../base/_utils";

export const staff = [
  // Randy Welniak
  {
    id: "randyWelniak",
    image: "assets/media/pages/contact/our-staff/randy-welniak-v2.jpg",
    name: "Randy Welniak",
    title: "Deputy Athletic Director for Revenue and External Relations",
    phone: "307-766-6161",
    email: "rwelniak@uwyo.edu",
    bio: html`<p>Bio coming soon...</p>`,
  },
  // Derek Gossler
  {
    id: "derekGossler",
    image: "assets/media/pages/contact/our-staff/derek-gossler.jpg",
    name: "Derek Gossler",
    title: "Senior Associate Athletic Director for Development/Chief Revenue Officer",
    phone: "307-766-2994",
    email: "dgossler@uwyo.edu",
    bio: html`
      <p>
        Derek Gossler is in his fourth year as the University of Wyoming and first as the Senior
        Associate Athletic Director -Development and Chief Revenue Officer in 2025-26. Gossler
        served his first three years as the Associate Athletic Director for Development and Revenue
        Generation. In his role, Gossler manages all fundraising activities, premium seating,
        secondary market and ticket pricing strategies, works collaboratively with the Wyoming Sport
        Properties team and oversees Wyoming's development staff.
      </p>
      <p>
        In his first year at UW, Gossler successfully led the Cowboy Joe Club to record-breaking
        FY22 performances in both cash raised and pledges. The Cowboy Joe Club has since surpassed
        that total in both FY23 and FY24, a three-year stretch of record-breaking fundraising.
        Gossler also helps to lead all revenue-generating activities for Wyoming Athletics,
        providing leadership across multiple functions while serving as a member of senior
        administration.
      </p>

      <p>
        Prior to his arrival in Laramie, Gossler served as the Associate Athletic Director for
        External Operations at the United States Air Force Academy from 2017-22. There, he oversaw
        all aspects of external operations and revenue generation, including fundraising,
        marketing/fan experience, digital media, ticket operations, ticket sales, premium seating, ,
        advertising, team store sales, and community outreach. Additionally, Gossler directed
        strategic goals, objectives and vision while growing, mentoring, and managing a diverse
        staff of 23 employees.
      </p>

      <p>
        Included in his many accomplishments, Gossler led the Air Force development team to five
        straight record-setting fundraising years in terms of membership and dollars raised for Air
        Force Athletics. In that span, membership and dollars raised each increased over 100%. He
        closed the two largest gifts from individuals in Air Force Academy Corporation history,
        oversaw a successful rebrand of the Falcon Pride Club to Falcon Athletic Fund and
        development of a major giving program from scratch. In addition to fundraising
        accomplishments the Air Force Athletics external team set several ticket revenue records,
        experienced exponential social media growth and set high marks for team store sales in
        partnership with Fanatics. Gossler also led negotiations for and implementation of
        partnerships with Paciolan, Opendorse, Learfield Amplify and REVELxp.
      </p>
      <p>
        He came to the Academy from Arizona State University. At ASU, Gossler served as Director of
        Major Gifts from 2014 to 2017 in the Sun Devil Club, the primary fundraising arm of ASU
        Athletics. The Sun Devil Club team broke numerous fundraising records during his time there,
        including $86 million in donations for FY 15' and memberships more than doubled to over
        16,000 members. Derek primarily focused on fundraising for the Reinvention of Sun Devil
        Stadium and for the emergence of sports that ASU added to their Division 1 offerings (Men's
        Ice Hockey, Women's Triathlon, Women's Lacrosse and Men's Tennis). This included working
        with the lead Hockey donors who contributed $32 million to make these opportunities a
        reality.
      </p>
      <p>
        Prior to joining ASU, Gossler served as Director of Development in the Rebel Athletic Fund
        for UNLV Athletics. His primary responsibilities included identifying, cultivating and
        soliciting major gifts and high end annual giving prospects for the Rebel Athletic Fund.
        During his time at UNLV, both annual dollars and members doubled.
      </p>
      <p>
        Gossler started his career at the University of Arizona in the Wildcat Club, after a year as
        a Development Assistant he was promoted to Development Associate. He served in this role
        assisting with two Capital Campaigns before rejoining former Athletic Director, Jim
        Livengood at UNLV.
      </p>
      <p>
        Derek is a native of Seattle, Washington and earned his bachelor's degree from the
        University of Washington in 2008, and a master's degree in Intercollegiate Athletic
        Administration from University of Washington in 2011. Derek currently resides in Laramie
        with his wife, Danielle.
      </p>
    `,
  },
  // Alex Jewell
  {
    id: "alexJewell",
    image: "assets/media/pages/contact/our-staff/alex-jewell-2025.jpg",
    name: "Alex Jewell",
    title: "Associate Athletic Director for Development and Revenue Generation",
    phone: "307-766-6168",
    email: "Ajewell3@uwyo.edu",
    bio: html`
      <p>
        Alex Jewell, a 2022 College Sports Communicators “30 Under 30” honoree, currently serves as
        the Associate Athletic Director for Development and Revenue Generation at the University of
        Wyoming. Now in his third year with Wyoming Athletics, Jewell helps the Cowboy Joe Club,
        UW's primary fundraising arm supporting more than 400 student-athletes across 17 varsity
        programs.
      </p>
      <p>
        Since joining the Cowboys in 2023, Jewell has held progressive leadership
        positions—including Director and Senior Director of Athletic Development—before being
        elevated to his current role in 2024. He has helped secure record-breaking fundraising
        efforts, including over $4.25 million in annual giving in FY24 and more than $2.0 million in
        new major gift commitments secured over the past 12 months. Jewell also helped spearhead the
        creation and launch of the 7220 Society, Wyoming Athletics' first-ever major gift society,
        which has generated over $4.2 million in philanthropic support since December 2024.
      </p>

      <p>
        In his current position, Jewell helps oversee the day-to-day operations of the Cowboy Joe
        Club, helps guide and lead the organization's external strategy, supervises multiple
        full-time and intern staff, manages a portfolio of donors, and serves alumni and supporters
        across Wyoming. He plays a key role in executing strategic fundraising campaigns and donor
        outreach efforts—most notably the "Restore The War" campaign, a transformative two-phase
        renovation of War Memorial Stadium's west side set to conclude in 2025.
      </p>

      <p>
        Jewell also serves as a member of Wyoming Athletics' External Operations Team, working
        closely with leadership across departments—including ticketing, marketing, licensing, and
        NIL—to align strategic growth across all revenue-generating channels.
      </p>
      <p>
        Prior to arriving in Laramie, Jewell served as Director of Athletic Media Relations at
        Eastern Michigan University, where he oversaw all day-to-day media operations, creative
        direction, and storytelling efforts for EMU Athletics. He also served as co-host and
        producer of the Eastern Insider Podcast, led EMU's first major virtual fundraising event,
        and directed the creation of the department's first-ever digital and social media branding
        style guide, now fully integrated across operations.
      </p>
      <p>
        During his time at EMU, Jewell worked as the primary media contact for several programs,
        including football and baseball, and played a leading role in department-wide external
        relations efforts, Hall of Fame initiatives, strategic donor engagement, and special events.
        He also contributed to EMU's 2021-22 NACMA Promotion of the Year and supported major
        facility and alumni reunion events, including the 1970 National Championship celebration.
      </p>
      <p>
        A native of Midland, Michigan, Jewell holds both a Master of Science in Sport Management and
        a Bachelor of Business Administration in Marketing from Eastern Michigan University, where
        he also got his start in athletics as a student assistant in the Equipment Room.
      </p>
      <p>
        Jewell is an active member of College Sports Communicators, where he serves on the Inclusion
        Committee and contributes to national conversations on inclusive practices and
        student-athlete well-being.
      </p>
    `,
  },
  // Karen Marr
  {
    id: "karenMarr",
    image: "assets/media/pages/contact/our-staff/karen-marr-2025.jpg",
    name: "Karen Marr",
    title: "Comptroller for External Operations",
    phone: "307-766-6246",
    email: "kbarker1@uwyo.edu",
    bio: html`
      <p>
        Karen Marr is in her fourth year as the Comptroller for the Cowboy Joe Club and external
        operations at the University of Wyoming in 2025-26. In her role with the CJC, Marr works to
        ensure integrity of general ledger data, while also entering all CJC contracts,
        requisitions, and purchase orders. Additionally, she oversees regular accounting tasks and
        serves numerous gameday roles inside the Wildcatter suites, IPF tailgate area, and Mickeys.
      </p>
      <p>
        Prior to her arrival at UW Athletics, Marr was a staff accountant for Medicine Bow
        Technologies in Laramie. There, she maintained AR, AP, invoicing, prepaid accounts, and
        inventory accounts. She also collaborated with leadership on accounting and financial
        data-related topics, and created client profitability reports, among numerous other
        responsibilities.
      </p>
      <p>
        No stranger to the University of Wyoming, Marr was the accountant for the Department of
        Animal Science between 2014-17.
      </p>
      <p>
        Marr earned her bachelor's degree in accounting from the University of Northern Colorado in
        May of 2009 before earning a master's degree in accounting from the University of Wyoming in
        2010.
      </p>
      <p>
        Marr and her husband, Joe, have four children: Caleb, Winifred, Aria, and Griffin. The
        family resides in Laramie with their dog, Midna.
      </p>
    `,
  },
  // Juan Soto
  {
    id: "juanSoto",
    image: "assets/media/pages/contact/our-staff/juan-soto-2025.jpg",
    name: "Juan Soto",
    title: "Senior Director of Development and Premium Seating",
    phone: "307-766-6206",
    email: "jsoto1@uwyo.edu",
    bio: html`
      <p>
        Juan Soto is in his third year as the Director of Development/Premium Seating at the
        University of Wyoming and fourth overall at the Cowboy Joe Club in 2025-26. In his role,
        Soto works to identify, cultivate, and solicit annual fund donations, capital projects, and
        Cowboy Joe Club memberships. Additionally, he oversees premium seating for football and
        basketball.
      </p>
      <p>
        Soto has been instrumental in shaping Wyoming Athletics' premium seating strategy, playing a
        key role in the day-to-day execution of the all-new Wyo Sports Ranch Club, set to debut in
        2025. In addition to securing multiple major gift commitments tied to the project, Soto has
        successfully led the sales and allocation of all new premium seating inventory, while
        working closely with senior leadership to ensure alignment with the department's long-term
        vision and donor engagement goals.
      </p>
      <p>
        Prior to arriving at UW, Soto served as the General manager of Laramie's Library Sports
        Grille and Brewery between 2011-2015 and 2018-2021. He handled all aspects of the
        restaurant's operations, including day-to-day oversight, community relations, and more.
      </p>
      <p>
        In addition to his role at the Library Sports Grille and Brewery, Soto gained experience in
        the world of athletics through a position in guest relations with the Colorado Rockies for
        the 2021 and 2022 seasons. In 2022 Soto started in the University of Wyoming Athletic
        Department with a position at Wyovision and an internship with Media Relations.
      </p>
      <p>
        From 2015-2018, Soto worked for Trigon Sports International for three years. A Memphis,
        Tenn.-based company, Trigon Sports International is a leading online distributor of sports
        and athletic training equipment in the United States. At Trigon, Soto was directly
        responsible for maintaining and acquiring new accounts in 17 states in the upper Midwest and
        Northeast regions of the country.
      </p>

      <p>
        A member of the National Association of Collegiate Directors of Athletics (NACDA), Soto was
        selected in 2023 for the 16th annual Diversity Initiative Program and in 2024 for the 17th
        annual Diversity Initiative Program, presented by the National Association of Athletic
        Development Directors (NAADD). He was one of 40 recipients nationwide to earn the honor.
      </p>
    `,
  },
  // Isaac Decker
  {
    id: "isaacDecker",
    image: "assets/media/pages/contact/our-staff/decker-isaac.webp",
    name: "Isaac Decker",
    title: "Director of Development",
    phone: "307-766-6247",
    email: "idecker@uwyo.edu",
    bio: html`
      <p>
        Isaac Decker is in his first year as the Director of Development with the Cowboy Joe Club in
        2025-26. In his role, Decker will oversee the annual Cowboy Joe Club Golf Series, while also
        working with a portfolio of donors and to further increase the development of the CJC's
        annual fund.
      </p>
      <p>
        In his role with the Jayhawks, Decker managed a portfolio of more than 100 donor accounts
        totaling over $2.4 million in contributions. Through strategic cultivation and
        relationship-building, he helped generate over $1 million in new philanthropic revenue,
        consistently surpassing annual benchmarks. Decker also served as a frontline liaison for
        donors and played an integral role in advancing the department's mission through meaningful
        engagement and stewardship.
      </p>
      <p>
        As a Ticket Sales & Service Intern with the Washington Nationals, he supported the launch of
        the Nats Plus membership program and contributed to theme night operations while conducting
        high-volume outbound sales outreach. His prior internship with VMG Sports Agency allowed him
        to gain early exposure to the growing world of Name, Image, and Likeness (NIL), supporting
        collegiate athletes in building their personal brands and securing sponsorship
        opportunities.
      </p>
      <p>
        Decker has also held roles with the Wichita Wind Surge, where he successfully close over
        $70,000 in group ticket sales and provided key gameday support. He also worked in collegiate
        athletics at Friends University, where he contributed to the launch of a revenue-generating
        affiliate marketing program and assisted in planning major fundraising events.
      </p>
      <p>
        Decker earned his Bachelor of Science in Sport Management and minor in business from the
        University of Kansas in 2022.
      </p>
    `,
  },
  // Kade Russow
  {
    id: "kadeRussow",
    image: "assets/media/pages/contact/our-staff/kade-rusow-2025.jpg",
    name: "Kade Russow",
    title: "Director of Development for Donor Relations",
    phone: "307-766-3777",
    email: "krussow1@uwyo.edu",
    bio: html`
      <p>
        Kade Russow is in his third year as the Director of Development for Donor Relations in
        2025-26. In his current role, Russow plays a major role in executing CJC events such as the
        annual Cowboy Joe Club Auction, while also maintaining direct oversight of the department's
        Steer-A-Year program.
      </p>
      <p>
        In 2024, Russow helped lead the Cowboy Joe Club to yet another historic auction result, as
        the event brought in more than $600,000 and 600 attendees. With State of Wyoming matching
        dollars, the 2024 Cowboy Joe Club Auction raised nearly 1.2 million dollars for the 400+
        student-athletes of Wyoming Athletics. His efforts also helped secure one of the auction's
        highest-ever results in procured donation items, with more than 250 silent auction items,
        and 30 live auction items.
      </p>

      <p>
        Russow also directs the Steer-A-Year program, one of the nation's most innovative giving
        programs which connects the Wyoming agricultural community with Wyoming Athletics. In
        FY2024, the Steer-A-Year program accounted for more than $300,000 in revenue generated.
        Russow also manages a portfolio of donors, and has secured multiple major gift commitments
        as part of the all-new 7220 Society in FY2024.
      </p>
      <p>
        Prior to joining the Cowboy Joe Club, Russow was the Director of Rodeo Operations and
        Marketing for the University of Wyoming Rodeo team from 2022-23. Russow executed and
        organized annual fundraising for the University of Wyoming Rodeo Team of over $300,000 in
        2023, while coordinating and serving as the main liaison for academic excellence for the UW
        Rodeo team, which included an overall 3.0 team GPA. He also managed animal care and welfare
        for over 200 head of UW Rodeo practice livestock, managed UW Rodeo Social Media Accounts,
        organized team travel, and aided in the recruitment process for UW Rodeo prospective
        athletes. During Russow's tenure, UW Rodeo Women's team placed 3rd nationally at the 2023
        College National Finals Rodeo.
      </p>
    `,
  },
  // Amber Layton
  {
    id: "amberLayton",
    image: "assets/media/pages/contact/our-staff/placeholder.jpg",
    name: "Amber Layton",
    title: "Coordinator, Development - CJC Internal Operations",
    phone: "307-766-3050",
    email: "alayton4@uwyo.edu",
    bio: html`
      <p>
        Amber Layton is in her first year as the Development Coordinator, Interal Operations with
        the Cowboy Joe Club in 2025-26. In her role, Layton helps in the day-to-day administrative
        tasks of the office, including donor processing, portfolio upkeep, donor relations, and
        more.
      </p>
      <p>
        This is Layton's second stint with the CJC, previously serving as the Senior Office
        Associate in 2023-24 before returning again in 2025. Prior to arriving in the Cowboy Joe
        Club, Layton served as an office associate within the UW athletic department, focusing
        mainly on the University's trademark operations, as well as assisting the women's basketball
        and volleyball programs, respectively.
      </p>
      <p>
        Before entering intercollegiate athletics, Layton served as a preschool teacher at Abundance
        Creative Arts. Layton earned her bachelor's degree in Communication at the University of
        Wyoming in 2018.
      </p>
    `,
  },
];
